import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

export const SUPPORTED_LANGUAGES = ['de', 'en', 'es', 'zh-CN', 'fr', 'it'];
export const DEFAULT_LANGUAGE = 'en';
export const NAMESPACES = ['common', 'navigation', 'teamRequestForm', 'setupPage', 'adminPage', 'requestsPage', 'notifications', 'errors'];

// 🔍 DEBUG: Log i18n initialization
console.log('[i18n] Initializing i18next with:', {
  supportedLanguages: SUPPORTED_LANGUAGES,
  defaultLanguage: DEFAULT_LANGUAGE,
  namespaces: NAMESPACES,
});

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: SUPPORTED_LANGUAGES,
    ns: NAMESPACES,
    defaultNS: 'common',
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'requestateam_language',
      caches: ['localStorage'],
    },
    interpolation: { escapeValue: false },
    react: { useSuspense: true },
  });

// 🔍 DEBUG: Log language change events
i18n.on('languageChanged', (lng) => {
  console.log('[i18n] Language changed to:', lng, {
    timestamp: new Date().toISOString(),
    localStorage: localStorage.getItem('requestateam_language'),
    i18nLanguage: i18n.language,
  });
});

i18n.on('loaded', (loaded) => {
  console.log('[i18n] Resources loaded:', loaded);
});

export default i18n;
